// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeClientPasswordMoal_wrapper__UtFF1","input":"ChangeClientPasswordMoal_input__k248j","btns":"ChangeClientPasswordMoal_btns__oVOLH"};